import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';

import AutoComplete from '../MultiAutoComplete';
import { showDialog } from '../../../redux/actions/dialogs';

const buildOption = (tag) => ({ label: tag, value: tag });

const fetchSuggestions = (tags) => {
  return (query) => {
    const lcQuery = (query || '').toLowerCase();
    return Promise.resolve(tags.filter((tag) => tag.toLowerCase().indexOf(lcQuery) >= 0).slice(0, 10))
      .then((tags) => tags.map(buildOption) );
  };
};

class Tags extends React.Component {
  state = {
    tag: '',
  };

  handleKeyPress = (evt) => {
    console.log('handleKeyPress', this.state);
    if (evt.key === 'Enter') {
      this.addTag();
    }

    evt.stopPropagation();
  };

  addTag = () => {
    const { tag } = this.state;
    if (tag && tag.trim()) {
      this.props.onChange(_.concat(this.props.tags, [tag]));
      this.setState({
        tag: '',
      });
    }
  };

  handleTagChange = (tag, valid) => {
    console.log('handleTagChange', tag, valid);
    this.setState({
      tag,
    });
  };

  render() {
    const { tags, onChange, availableTags, label, helperText, ...other } = this.props;
    return (
      <AutoComplete
        label={label}
        helperText={helperText}
        loadOptions={fetchSuggestions(availableTags)}
        value={(tags || []).map(buildOption)}
        onChange={(value) => onChange(value.map(opt => opt.value)) }
        {...other}
        id="tag"
        isMulti
        placeholder="Add new tag..."
        tags={availableTags}
        allowCreate
      />);
  }
};

Tags.propTypes = {
  tags: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  showAll: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    availableTags: [], //state.getIn(['accounts', 'account', 'tags']).toJS(),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    showDialog,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Tags);



// WEBPACK FOOTER //
// ./src/components/Common/Tags/index.js